import { motion } from 'framer-motion';
import './Skills.scss';

const Skills = ({ isDarkMode, highlightedSkills = [], constraint }) => {
    const skills = [
        'Vue.js',
        'Javascript',
        'Typescript',
        'Node.js',
        'React.js',
        'Next.js',
        'HTML5',
        'CSS3',
        'SASS / SCSS',
        'GIT',
        'RESTful APIs',
        'MongoDB',
        'Express.js',
        'GraphQL',
        'jQuery',
        'Wordpress',
    ]; 

    return (
        <motion.div drag dragConstraints={constraint} className={`skills-container ${isDarkMode ? 'dark' : 'light'}`}>
            <h2>Skills</h2>
            <ul className="skills-list">
                {skills.map((skill, index) => (
                    <li 
                        key={index} 
                        className={`skill-item ${highlightedSkills.includes(skill) ? 'highlighted' : ''}`}
                    >
                        {skill}
                    </li>
                ))}
            </ul>
        </motion.div>
    );
};

export default Skills;

